export function isFloorPlanOverride(floorPlan) {
  return floorPlan ? Object.prototype.hasOwnProperty.call(floorPlan, 'matches') : false;
}
export function isFloorPlanDefault(floorPlan) {
  if (!floorPlan || !Object.prototype.hasOwnProperty.call(floorPlan, 'matches')) {
    return true;
  }

  return false;
}